import { Component, OnInit, Input } from '@angular/core';
// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

// Servicio
import { EmpleadosServicio } from '../../../services/empleado.service';
import { RutasService } from '../../../services/rutas.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import { RegionesService } from '../../../services/regiones.service';

@Component({
  selector: 'app-editar-ruta',
  templateUrl: './editar-ruta.component.html',
  styleUrls: ['./editar-ruta.component.css']
})
export class EditarRutaComponent implements OnInit {
  @Input() ruta: any;
  @Input() modals: AlertasModales;
  form: FormGroup;
  desactivarRuta = false;
  regiones = [];
  subRegiones = [];
  constructor(public activeModal: NgbActiveModal,
              private empleadoService: EmpleadosServicio,
              private rutaService: RutasService,
              private regionesService: RegionesService) {

  }

  ngOnInit() {
    // Inicializar el formulario
    this.form = new FormGroup({
      'ID_RUTA': new FormControl(this.ruta.ID_RUTA),
      'estado': new FormControl(this.ruta.estado),
      'nombreRuta': new FormControl(this.ruta.nombre, Validators.required),
      'codigoRuta': new FormControl(this.ruta.codigo),
      'cobro_meta': new FormControl(this.ruta.cobro_meta),
      'descripcionRuta': new FormControl(this.ruta.descripcion, Validators.required),
      'ID_EMPLEADO': new FormControl(this.empleadoService.datosEmpleado.ID_EMPLEADO),
      'requiere_aprobacion': new FormControl(this.ruta.requiere_aprobacion),
      'requiere_aprobacion_monto': new FormControl(this.ruta.requiere_aprobacion_monto),
      'ID_REGION': new FormControl(this.ruta.ID_REGION),
      'ID_SUB_REGION': new FormControl(this.ruta.ID_SUB_REGION)
    });
    const subcription = this.regionesService.regiones().subscribe( regiones => {
      this.regiones = regiones;
      subcription.unsubscribe();
    });
    this.initSubRegiones();
    if (this.ruta.ID_REGION) {
     this.loadSubRegiones(this.ruta.ID_REGION);
    }
  }

  initSubRegiones() {
    this.form.get('ID_REGION').valueChanges.subscribe(value => {
      if (value) {
        this.loadSubRegiones(value);
      } else {
        this.form.get('ID_SUB_REGION').setValue('');
        this.subRegiones = [];
      }
    });

  }

  loadSubRegiones(ID_REGION) {
   const subcription = this.regionesService.subRegiones(ID_REGION)
    .subscribe(result => {
      this.subRegiones = result;
      subcription.unsubscribe();
    });
  }
  asignarRequired() {
    if (this.form.get('requiere_aprobacion').value) {
      this.form.get('requiere_aprobacion_monto').setValidators(Validators.required);
    } else {
      this.form.get('requiere_aprobacion_monto').clearValidators();
      this.form.get('requiere_aprobacion_monto').updateValueAndValidity();
    }
  }

  guardar() {
    this.rutaService.editarRuta(this.form.value).subscribe(res => {
      if (res) {
        this.activeModal.close(res);
      }
    }, err => {
      if (err.status === 403) {
        this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
        'red',
        'modern',
        false,
        'fa fa-file-text');
      } else {
        this.modals.validacionesModalJquery('Error de validación', err.error, 'red');
      }
    });
  }

  desactivarRutaMsg() {
    this.desactivarRuta = true;
  }
  activarRutaFTCN() {
    this.form.get('estado').setValue(0);
    this.guardar();
  }

  desactivarRutaFTCN() {
    this.form.get('estado').setValue(1);
    this.guardar();
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/editar-ruta/editar-ruta.component.ts